import datos from "src/services/datos";
import esArray from "src/general_components/functionEsArray";

function chunkArray(array, size) {
  const result = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
}


export const postDigitalizacion = async (dataImagen, updateImageSave) => {
  let filesImages = [];

  dataImagen.forEach((item) => {
    if (item.save === false) {
      item.image = item.image.replace(/^data:image\/[a-z]+;base64,/, "");
      filesImages.push(item);
    }
  });

  // dividir en chunks de 150
  const chunks = chunkArray(filesImages, 150);

  const objetoImages = new datos("images");

  // acumuladores de respuesta
  let fullMessage = "";
  let allImages = [];
  let completed = false;       // al menos un chunk procesado
  let fullyCompleted = true;   // si todos los chunks se procesaron bien
  let processedCount = 0;

  // procesar secuencialmente
  for (let i = 0; i < chunks.length; i++) {
    const group = chunks[i];
    const data = { images: group };
    const response = await objetoImages.createImagesMultiple(data);

    // si status false, cortamos la ejecución
    if (response?.status === false || response?.status === "false") {
      fullyCompleted = false;
      return {
        monitor_transaction_id: "0",
        status: "false",
        completed,          // hasta acá, false si falló en el primer chunk
        fullyCompleted,     // false porque no terminó del todo
        message: response.message || "Error al procesar las imágenes.",
        message_error: `Solo se pudieron procesar ${processedCount} imágenes. Vuelva a intentar las que faltaron procesar.`,
        wsResponse: {
          images: {
            image: allImages,
          },
        },
      };
    }

    // si llegamos acá, al menos un chunk salió bien
    completed = true;

    // acumular mensaje
    if (response?.message) {
      fullMessage += response.message + " ";
    }

    const arrayImages = esArray(response?.wsResponse?.images?.image) || [];
    // acumular imágenes
    if (arrayImages) {
      allImages = [...allImages, ...arrayImages];
      processedCount += arrayImages.length;
    }
  }

  // construir respuesta final
  return {
    monitor_transaction_id: "0",
    status: "true",
    completed,          // true si al menos un chunk salió bien
    fullyCompleted,     // true porque todos los chunks procesaron correctamente
    message: fullMessage.trim(),
    wsResponse: {
      images: {
        image: allImages,
      },
    },
  };
};




export const actualizarDigitalizaciones = async (updateImageSave) => {
  const items = Object.values(updateImageSave);
  const arrayUnificado = items.flat();

  // Separamos en dos arrays:
  const conFolio = [];
  const conValor = [];

  const arrayConFoliosYvalores = separarFoliosYValores(arrayUnificado);

  // Aplanar el array
  const arrayConObjetosSeparado = arrayConFoliosYvalores.flatMap(item => Array.isArray(item) ? item : [item]);

  arrayConObjetosSeparado.forEach(obj => {
    if ('folio' in obj) {
      conFolio.push(obj);
    } else if ('valor' in obj) {
      conValor.push(obj);
    }
  });

  let response = [];
  if (conFolio.length > 0) {
    // Por ejemplo, solo insertamos los de conValor por ahora:
    const objectDigitalizacionesConFolio = new datos("digitalizaciones");
    response = objectDigitalizacionesConFolio.insert(conFolio);
  } 
  if (conValor.length > 0) {
    // Transformamos el array conValor para que solo tenga las 3 propiedades requeridas
    const conValorTransformado = conValor.map(obj => ({
      id_digitalizaciones: obj.id,
      id_metadatos: obj.id_metadatos,
      valor: obj.valor
    }));
    // Por ejemplo, solo insertamos los de conValor por ahora:
    const objectDigitalizacionesConValor = new datos("digitalizaciones_metadatos");
    response = objectDigitalizacionesConValor.insert(conValorTransformado);
  }


  return response;
};

function separarFoliosYValores(data) {
  const resultado = [];

  data.forEach(item => {
    const claves = Object.keys(item);

    // Detectar si hay mezcla de propiedades numéricas (índices) y 'folio'
    const clavesNumericas = claves.filter(k => !isNaN(k));
    const tieneFolio = 'folio' in item;

    // Caso 1: mezcla de folio + valores
    if (tieneFolio && clavesNumericas.length > 0) {
      // Agregamos solo el objeto del folio
      resultado.push({
        folio: item.folio,
        id: item.id
      });

      // Armamos un array con los valores indexados
      const valores = clavesNumericas.map(k => item[k]);
      resultado.push(valores); // Agregamos como array separado
    }
    // Caso 2: es solo un objeto folio puro
    else if (tieneFolio) {
      resultado.push(item);
    }
    // Caso 3: ya es solo un objeto de valores
    else {
      resultado.push(item);
    }
  });

  return resultado;
}



export const postDigitalizacionesCaratulas = async (dataImagen) => {
  let filesImages = [];
  // eslint-disable-next-line array-callback-return
  dataImagen.map((item) => {
    if (item.save === false) {
      //QUITAR data:image/png;base64, PARA QUE FUNCIONE EL POST
      item.image = item.image.replace(/^data:image\/[a-z]+;base64,/, "");
      filesImages.push(item);
    }
  });

  const objetoImages = new datos("images");
  const response = await objetoImages.createImages(filesImages);

  return response;
};

export const deleteImagesDigitalizaciones = async (id) => {
  const userData = new datos("digitalizaciones");
  let data = {
    id: id,
  };
  const response = await userData.delete(data);

  return response.status;
};

export const deleteImagesPrincipales = async (id) => {
  const userData = new datos("imagenes");
  let data = {
    id: id,
  };
  const response = await userData.delete(data);

  return response.status;
};
